import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../images/FFwedding.PNG';
import { SiWhatsapp } from 'react-icons/si';

const ClickHandler = () => {
    window.scrollTo(10, 0);
};

const Footer = (props) => {
    return (
        <footer>

            <div className="wpo-site-footer text-center" style={{ paddingTop: '40px', paddingBottom: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footer-image" style={{ marginBottom: '24px' }}>
                                <Link className="logo" to="/" aria-label="Home"><img src={Logo} alt="logo" /></Link>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="footer-link" style={{ margin: '0 0 32px' }}>
                                <ul>
                                    <li className="menu-item-has-children">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <Link to="/about">About</Link>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <Link to="/portfolio-photo">Photography</Link>
                                    </li>

                                    <li className="menu-item-has-children">
                                        <Link to="/hotc-films">Films</Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to="/inquiry1">Inquiry</Link>
                                    </li>

                                    <li><Link onClick={ClickHandler} className='menu-item-has-children' to="/careers">Careers</Link></li>
                                    <li><Link onClick={ClickHandler} className='menu-item-has-children' to="/travel">Travel</Link></li>
                                    <li><Link onClick={ClickHandler} className='menu-item-has-children' to="/backyard">Backyard</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="link-widget" style={{ marginBottom: '20px' }}>
                                <ul style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', padding: 0, margin: 0, listStyle: 'none' }}>
                                    <li><a href="https://www.facebook.com/FFweddingz" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fi flaticon-facebook-app-symbol" style={{ lineHeight: 1 }}></i></a></li>
                                    <li><a href="https://api.whatsapp.com/send/?phone=919925876341&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><SiWhatsapp /></a></li>
                                    <li><a href="https://www.instagram.com/ff_weddingz/" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fi flaticon-instagram-1" style={{ lineHeight: 1 }}></i></a></li>
                                    <li><a href="https://pin.it/52uQbnEZg" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="fi flaticon-pinterest" style={{ lineHeight: 1 }}></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="footer-contact-info" style={{ margin: '0 0 24px', fontSize: '15px' }}>
                                <a href="tel:+919925876341" style={{ color: '#D4B0A5', textDecoration: 'none' }}>+91 99258 76341</a>
                                <span style={{ margin: '0 10px', color: '#D4B0A5' }}>·</span>
                                <a href="mailto:info@ffweddingz.com" style={{ color: '#D4B0A5', textDecoration: 'none' }}>info@ffweddingz.com</a>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="copyright" style={{ marginTop: '0px' }}>
                                <p>©2026  <Link to="/">FFweddingz.</Link> All right reserved   | Developed by    <a
                                    href="https://settingsinfotech.com/"
                                    className="text-teal-600 hover:underline ml-1"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#007bff' }}
                                >
                                    Settings Infotech
                                </a>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
